import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

function TechInfo(){
    
    return (
        <div className='page-wrapper'>
            <NavBar/>
            <main>
                <h1>Tech Info</h1>
                <h3>Zirconia Increasing Translucency Summary</h3>
                    <div className='centered' style={{paddingBottom: '3rem'}}>
                        <table>
                            <tr>
                                <th>Yttria mol%</th>
                                <th>Translucency %</th>
                                <th>Strength (MPa)</th>
                                <th>Damage Resistant</th>
                                <th>Minimum Thickness</th>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>33%</td>
                                <td>900-1000(1200)</td>
                                <td>Yes</td>
                                <td>0.6 (0.4)</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>41%</td>
                                <td>750</td>
                                <td>Yes</td>
                                <td>0.8 (0.5)</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>49%</td>
                                <td>600</td>
                                <td>NO! (300 MPa)</td>
                                <td>1.0 (0.7)</td>
                            </tr>
                        </table>
                    </div>
                    <div className='centered'>
                        <img className='tech-info-img' src='/img/IMG_3406.PNG'/>
                        <img className='tech-info-img' src='/img/implant-tech-info-1.jpg'/>
                        <img className='tech-info-img' src='/img/implant-tech-info-2.jpg'/>
                    </div>
            
            </main>
            <Footer/>
        </div>
    )
}

export default TechInfo;